import { Model } from '@models'
import { validateDateRange } from '@src/models/helper'
import reducers from '@src/screens/Plan/models/plan.reducers'
import { endOfCurrentWeek, startOfCurrentWeek } from '@src/screens/ActionGoals/utils'

const initPlanCalendar = () => ({
  startDate: startOfCurrentWeek(),
  endDate: endOfCurrentWeek(),
})

export default class Plan {
  namespace = 'plan'

  state = {
    ...Model.defaultState,
    calendar: initPlanCalendar(),
  }

  effects = {
    changeDateRange: Model.buildEffect({
      name: `${this.namespace}/changeDateRange`,
      validation: validateDateRange,
      reducers: [{ name: 'updateCalendarState' }],
    }),
  }

  reducers = reducers
}
